export const FISERV_TOKEN_TYPE = 'CLAIM_CHECK_NONCE' as const;

export const FISERV_ACCOUNT_TYPE = 'CREDIT' as const;
